@if (!info.hideCloseButton) {
  <button
    [id]="info.closeModalBtnId"
    (click)="clickCloseModal()"
    [disabled]="loadingInfo.condition"
    class="modal__close">
    <svg width="8" height="8" class="icon">
      <use xlink:href="#large-cross"></use>
    </svg>
  </button>
}
@if (info.header) {
  <header class="modal__heading" [ngClass]="{ 'heading-with-form': info.header.withForm }">
    <div class="modal__main">
      @if (info.header.title) {
        <h3 class="modal__title">
          {{ info.header.title | translate }}
          @if (info.header.titleWithEllipsis) {
            ...
          }
        </h3>
      }
      @if (info.header.withTooltip) {
        <svg
          width="14"
          height="14"
          class="icon info-icon"
          [wdTooltip]="info.header.tooltipInnerHtml || info.header.tooltipText"
          [wdTooltipWidth]="324"
          [wdTooltipAllowHtml]="!!info.header.tooltipInnerHtml"
          [wdTooltipPosition]="'bottom'">
          <use xlink:href="#info-icon"></use>
        </svg>
      }
      @if (info.header.subtitle) {
        <span class="modal__subtitle">
          {{ info.header.subtitle | translate }}
        </span>
      }
    </div>
    <ng-container [ngTemplateOutlet]="titleContent"></ng-container>
    @if (info.header.text) {
      @if (!info.header.innerHtmlForText) {
        <p class="modal__text" [ngClass]="info.header.textExtraClass">
          {{ info.header.text | translate }}
        </p>
      } @else {
        <p
          class="modal__text"
          [innerHTML]="info.header.text | translate"
          [ngClass]="info.header.textExtraClass"
          [class.break-spaces]="info.header.textWithBreakSpaces"></p>
      }
    }
    <ng-container [ngTemplateOutlet]="textContent"></ng-container>
    <ng-container [ngTemplateOutlet]="contentOnHeader"></ng-container>
  </header>
}
